import { Component, OnInit } from '@angular/core';
import { Route } from '@angular/router';
import { User, AuthService } from '@auth0/auth0-angular';

import { SubscriptionService } from '../../pages/vv/services/subscription.service';
import { tap } from 'rxjs';
@Component({
  selector: 'app-workarea-list',
  templateUrl: './workarea-list.component.html',
  host: {
    class: 'h-full'
  }
})
export class WorkareaListComponent implements OnInit {

  profileJson: User | null | undefined = null;
  profileObj: string = '';
  claims: string = '';
  menuitems: Route[] = []
  constructor(
    public auth: AuthService,
    private subscriptionService: SubscriptionService) { }

  ngOnInit(): void {
    this.auth.user$.subscribe(
      (profile) => {
        this.profileJson = profile;
        this.profileObj = JSON.stringify(profile, null, 2);
        // console.log("PROFILE", profile)
      }
    );
    this.auth.idTokenClaims$.subscribe(
      claims => {
        this.claims = JSON.stringify(claims, null, 2)
        // console.log("CLAIMS", claims)
      }
    )
    this.subscriptionService.activations$.pipe(
      tap(waa => {
        let slugs = waa.workarea_activation.map(a => a.workarea.slug)
        this.menuitems = waa.workarea_activation.map(item => ({
          path: `wa/${item.workarea.slug}`,
          children: item.workarea.config?.menu?.children || [],
          data: {
            ...(item.workarea.config?.menu || {}),
            id: item.workarea.slug,
            workareaSlug: item.workarea.slug,
            name: item.workarea.name,
            children: undefined
          }
        }))
      })).subscribe()

  }

}
